import React from 'react';
import RegistrationHero from '../components/RegistrationHero';
import McaRegistration from '../components/McaRegistration';

const CompanyRegistration = () => {
  return (
    <div className="gfi-registration-page-wrapper">
      
      {/* 1. INITIAL WIDE INNER HERO BANNER SECTION */}
      <RegistrationHero />
      <McaRegistration />
      {/* 2. Next Legal Certificates Blocks Aur Layouts Yahan Par Add Honge */}

    </div>
  );
};

export default CompanyRegistration;